import React from "react";
import { Route, Redirect } from "react-router-dom";
import {route} from '../Utils/constants.js';
import { showModulesAccess } from '../Utils/onlyProductAccess'

export const ProtectedRoute = ({
  component: Component,granted,isAdmin,modules,path,clean,
  ...rest
}) => granted && showModulesAccess(modules, path)? (
  <Route
      {...rest}
      render={props => {
          if (clean) clean()
          return( <Component {...props} />);
      }}
    />
) : (
  <Redirect
    to={{
      pathname: route.PATH
      // state: { from: location }
    }}
  />
) 




  
